import { render, staticRenderFns } from "./AttestationForm.vue?vue&type=template&id=bf5d683e&"
import script from "./AttestationForm.vue?vue&type=script&lang=js&"
export * from "./AttestationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports